import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Breadcrumb } from '../shared/components';
@Component({
    selector: 'app-configurations',
    standalone: false,
    templateUrl: './configurations.component.html',
})
export class ConfigurationsComponent implements OnInit {
    breadcrumb: Breadcrumb[] = [{ title: 'Configurações' }];
    activeTab = 'versao';

    constructor(private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            if (params['tab']) this.activeTab = params['tab'];
        });
    }
}
